import { render, staticRenderFns } from "./NeoparentSessExp.vue?vue&type=template&id=480184d6&scoped=true"
import script from "./NeoparentSessExp.vue?vue&type=script&lang=js"
export * from "./NeoparentSessExp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480184d6",
  null
  
)

export default component.exports